<template>
  <article class="box">

    <form @submit.prevent="save">

      <div class="user-container">
        <img
          class="comment-icon"
          :src="avatar_url">
        <div class="d-flex">
          <span class="my-input-container">
            <input
              :class="error && 'is-danger'"
              v-model="startTimeMins"
              placeholder="01"
              id="Field8-1" name="Field8-1" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
          </span>
          <span class="my-time-divider">:</span>
          <span class="my-input-container">
            <input
              v-model="startTimeSecs"
              placeholder="21"
              :class="error && 'is-danger'"
              id="Field8-2" name="Field8-2" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
          </span>
        </div>

        <div class="time-divider"></div>

        <div class="d-flex">
          <span class="my-input-container">
            <input
              v-model="endTimeMins"
              placeholder="09"
              :class="error && 'is-danger'"
              id="Field8-1" name="Field8-1" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
          </span>
          <span class="my-time-divider">:</span>
          <span class="my-input-container">
           <input
            v-model="endTimeSecs"
            placeholder="57"
            :class="error && 'is-danger'"
            id="Field8-2" name="Field8-2" type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
          </span>
        </div>
      </div>

      <div class="field">
        <p class="control">
          <textarea
            @keydown.esc="$emit('close')"
            @keydown.shift.enter="save"
            v-textautosize
            v-select
            :class="error && 'is-danger'"
            class="textarea"
            v-model="commentText"
            placeholder="Add a comment..."/>
        </p>
      </div>

      <div class="field">
        <p class="control flex-space-between">
          <button
            class="button is-info"
            :disabled="!commentText"
            :data-balloon="!commentText && 'Write something to add a comment.'"
            data-balloon-pos="right"
            :class="addingComment && 'is-loading'"
            type="submit"
          >Save</button>
          <button
            @click="$emit('close')"
            class="button"
          >Cancel</button>
        </p>
        <p class="commenting-error" v-if="error">
          Error creating comment
        </p>
      </div>

    </form>

  </article>
</template>

<script>
import { textautosize, select } from '../directives.js'

import { minsSecondsToSeconds, secsToMinsandSecs } from '../time.js'

import store from '../store.js'

export default {
  name: 'AddComment',
  props: {
    avatar_url: {
      type: String,
      required: true,
    },
    cycleID: {
      required: false,
    },
    videoID: {
      required: true,
    },
    currentTime: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      startTimeMins: '',
      startTimeSecs: '',
      endTimeMins: '',
      endTimeSecs: '',
      addingComment: false,
      error: false,
      commentText: '',
    }
  },
  mounted () {
    const [ startTimeMins, startTimeSecs ] = secsToMinsandSecs(this.currentTime)
    const [ endTimeMins, endTimeSecs ] = secsToMinsandSecs(this.currentTime + 20)

    this.startTimeMins = startTimeMins
    this.startTimeSecs = startTimeSecs
    this.endTimeMins = endTimeMins
    this.endTimeSecs = endTimeSecs
  },
  methods: {
    save () {
      const {
        commentText,
        endTimeSecs,
        endTimeMins,
        startTimeSecs,
        startTimeMins,
        cycleID,
        videoID,
      } = this

      const fieldsNotEmpty =
        startTimeMins !== '' && endTimeMins !== '' &&
        startTimeSecs !== '' && endTimeSecs !== '' &&
        commentText !== ''

      const endTime = minsSecondsToSeconds([endTimeMins, endTimeSecs])
      const startTime = minsSecondsToSeconds([startTimeMins, startTimeSecs])

      // TODO: validate this on the server side, not client.
      if (fieldsNotEmpty) {
        store.dispatch('addComment', {
          body: commentText,
          start_time: startTime,
          end_time: endTime,
          video: videoID,
          cycle: cycleID,
        })
      }
    },
  },
  directives: {
    textautosize,
    select,
  },
}
</script>

<style lang="scss" scoped>

@import '../_variables.scss';

.commenting-error {
  text-align: center;
  font-style: italic;
  font-size: 1.2rem;
  color: $DANGER;
}

.my-input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.my-input {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
}

.my-time-divider {
  padding-top: calc(0.375em - 1px);
}

.d-flex {
  display: flex;
}

.time-divider {
  width: 1rem;
  height: 3px;
  border-radius: 4px;
  background-color: gray;
  margin: 5px;
}

.user-container {
  display: flex;
  align-items: center;
}


.user-container > p {
  margin-right: 10px;
  margin-bottom: 0;
}


img.comment-icon {
  width: 48px;
  height: 48px;
  margin: 10px;
  margin-left: 0;
  margin-right: 10px;
  border-radius: 4px;
  background-color: $teal;
}
</style>



// WEBPACK FOOTER //
// AddComment.vue?18cdacdc